export default "__VITE_ASSET__BJnJbQEu__"